module.exports = __webpack_public_path__ + "img/logoAiPay.1eb03316.jpeg";